import { render, staticRenderFns } from "./CiVehicleAttachment.vue?vue&type=template&id=1a72081a&"
import script from "./CiVehicleAttachment.vue?vue&type=script&lang=js&"
export * from "./CiVehicleAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports